// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wt-civic-page {
  --civic-ink: #172336;
  --civic-navy: var(--civic-primary, #15395f);
  --civic-red: var(--civic-accent, #ba2d2d);
  --civic-gold: #e5a229;
  --civic-paper: var(--civic-surface, #f5f1e8);
  color: var(--civic-ink);
  font-family: var(--civic-font, inherit);
}

.wt-civic-hero {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  min-height: 270px;
  margin-bottom: 0;
  padding: 46px 52px;
  overflow: hidden;
  background: linear-gradient(120deg, var(--civic-navy) 0%, #1c4c76 64%, var(--civic-red) 100%);
  color: #fff;
}

.wt-civic-hero::after {
  content: '';
  position: absolute;
  right: -90px;
  bottom: -145px;
  width: 390px;
  height: 390px;
  border: 52px solid rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.wt-civic-hero-grid {
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background-image: linear-gradient(rgba(255, 255, 255, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.3) 1px, transparent 1px);
  background-size: 34px 34px;
}

.wt-civic-hero-copy,
.wt-civic-pulse {
  position: relative;
  z-index: 1;
}

.wt-civic-hero-copy {
  max-width: 720px;
}

.wt-civic-kicker {
  display: block;
  margin-bottom: 8px;
  color: var(--civic-gold);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.wt-civic-hero h1 {
  margin: 0 0 15px;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 52px;
  line-height: 1.05;
}

.wt-civic-hero p {
  max-width: 680px;
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 18px;
}

.wt-civic-pulse {
  width: 150px;
  text-align: right;
}

.wt-civic-pulse strong {
  display: block;
  color: #fff;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 46px;
  line-height: 1;
}

.wt-civic-pulse span {
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  text-transform: uppercase;
}

.wt-civic-sections-shell {
  position: relative;
  margin-bottom: 38px;
}

.wt-civic-sections-shell::before,
.wt-civic-sections-shell::after {
  content: '';
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 1px;
  width: 24px;
  pointer-events: none;
}

.wt-civic-sections-shell::before {
  left: 0;
  background: linear-gradient(90deg, var(--civic-paper), transparent);
}

.wt-civic-sections-shell::after {
  right: 0;
  background: linear-gradient(270deg, var(--civic-paper), transparent);
}

.wt-civic-sections {
  display: flex;
  gap: 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-color: var(--civic-red) #ded8cd;
  scrollbar-width: thin;
  border-bottom: 1px solid #d6d0c5;
  background: var(--civic-paper);
}

.wt-civic-sections:focus-visible {
  outline: 2px solid var(--civic-red);
  outline-offset: 2px;
}

.wt-civic-sections a {
  flex: 0 0 auto;
  padding: 15px 17px;
  border-bottom: 3px solid transparent;
  color: #4b5360;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.wt-civic-sections a.active,
.wt-civic-sections a:hover {
  border-bottom-color: var(--civic-red);
  color: var(--civic-red);
}

.wt-civic-section-heading,
.wt-civic-form-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
}

.wt-civic-section-heading h2,
.wt-civic-form-heading h3,
.wt-civic-detail-panel h2 {
  margin: 0;
  font-family: Georgia, 'Times New Roman', serif;
}

.wt-civic-directory,
.wt-civic-urgent,
.wt-civic-compare,
.wt-civic-form,
.wt-civic-signin {
  margin-bottom: 38px;
}

.wt-civic-filters {
  display: grid;
  grid-template-columns: minmax(220px, 2fr) minmax(150px, 1fr) minmax(150px, 1fr);
  gap: 12px;
  margin-bottom: 22px;
  padding: 16px;
  border: 1px solid #ddd6ca;
  background: #faf8f3;
}

.wt-civic-filters label span {
  display: block;
  margin-bottom: 5px;
  color: #667080;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.wt-civic-record-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.wt-civic-record {
  position: relative;
  min-width: 0;
  padding: 20px;
  border: 1px solid #d7dce2;
  border-top: 4px solid var(--civic-navy);
  background: #fff;
  box-shadow: 0 8px 22px rgba(17, 38, 62, 0.05);
}

.wt-civic-record.is-critical {
  border-top-color: var(--civic-red);
}

.wt-civic-record-topline,
.wt-civic-record-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.wt-civic-kind {
  color: #657080;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.wt-civic-status {
  padding: 3px 7px;
  border-radius: 2px;
  background: #e8edf2;
  color: #415268;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.wt-civic-status.status-verified,
.wt-civic-status.status-resolved {
  background: #dcefe5;
  color: #216441;
}

.wt-civic-record h3 {
  margin: 15px 0 9px;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 22px;
}

.wt-civic-record h3 a {
  color: var(--civic-ink);
}

.wt-civic-record p {
  color: #5b6470;
}

.wt-civic-record-meta {
  justify-content: flex-start;
  margin: 16px 0;
  color: #78818d;
  font-size: 11px;
}

.wt-civic-record-meta .severity-high,
.wt-civic-record-meta .severity-critical {
  color: var(--civic-red);
  font-weight: 800;
}

.wt-civic-progress {
  height: 6px;
  margin: 16px 0;
  overflow: hidden;
  background: #e7ebee;
}

.wt-civic-progress span {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, var(--civic-gold), #5b9b6c);
}

.wt-civic-empty {
  padding: 54px 20px;
  border: 1px dashed #c8c3b9;
  background: #faf8f3;
  text-align: center;
}

.wt-civic-empty .fa {
  color: #9aa1a8;
  font-size: 40px;
}

.wt-civic-form,
.wt-civic-signin,
.wt-civic-compare {
  padding: 26px;
  border: 1px solid #d8d1c4;
  background: var(--civic-paper);
}

.wt-civic-comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 1px;
  margin-top: 22px;
  background: #cfd5da;
}

.wt-civic-comparison-grid > div {
  padding: 22px;
  background: #fff;
}

.wt-civic-detail-breadcrumb {
  display: flex;
  gap: 8px;
  margin: 22px 0;
}

.wt-civic-detail-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-bottom: 28px;
  padding: 38px;
  background: linear-gradient(115deg, #f4f0e7, #fff);
  border-left: 7px solid var(--civic-red);
}

.wt-civic-detail-header h1 {
  margin: 0 0 10px;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 42px;
}

.wt-civic-detail-state {
  min-width: 150px;
  text-align: right;
  text-transform: uppercase;
}

.wt-civic-detail-state span,
.wt-civic-detail-state strong {
  display: block;
}

.wt-civic-detail-state span {
  color: var(--civic-red);
  font-weight: 800;
}

.wt-civic-detail-panel {
  margin-bottom: 20px;
  padding: 24px;
  border: 1px solid #d9dde2;
  background: #fff;
}

.wt-civic-detail-panel h2 {
  margin-bottom: 18px;
}

.wt-civic-description {
  white-space: pre-wrap;
}

.wt-civic-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.wt-civic-facts.stacked {
  grid-template-columns: 1fr;
}

.wt-civic-facts div {
  padding-bottom: 10px;
  border-bottom: 1px solid #edf0f2;
}

.wt-civic-facts dt {
  color: #77818e;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wt-civic-facts dd {
  margin-top: 4px;
}

.wt-civic-outcome {
  border-color: #d4b56d;
  background: #fffaf0;
}

.wt-civic-history {
  position: relative;
  margin: 0;
  padding: 0 0 0 22px;
  list-style: none;
}

.wt-civic-history::before {
  content: '';
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 4px;
  width: 2px;
  background: #d8dee4;
}

.wt-civic-history li {
  position: relative;
  margin-bottom: 22px;
}

.wt-civic-history li::before {
  content: '';
  position: absolute;
  top: 5px;
  left: -23px;
  width: 12px;
  height: 12px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--civic-red);
  box-shadow: 0 0 0 1px var(--civic-red);
}

.wt-civic-history time,
.wt-civic-history strong,
.wt-civic-detail-panel li small {
  display: block;
}

.wt-civic-history time,
.wt-civic-history small,
.wt-civic-detail-panel li small {
  color: #7c8590;
  font-size: 11px;
}

.wt-civic-detail-panel li {
  margin-bottom: 10px;
}

.wt-civic-knowledge-links {
  margin: 0;
  padding: 0;
  list-style: none;
}

.wt-civic-knowledge-links li {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid #edf0f2;
}

.wt-civic-knowledge-links li:last-child {
  border-bottom: 0;
}

.wt-civic-knowledge-links a,
.wt-civic-link-type {
  display: block;
}

.wt-civic-link-type {
  margin-bottom: 3px;
  color: var(--civic-red);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wt-civic-knowledge-links p {
  margin: 5px 0 0;
  color: #667080;
  font-size: 12px;
}

@media (max-width: 991px) {
  .wt-civic-record-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .wt-civic-hero {
    padding: 38px 30px;
  }

  .wt-civic-hero h1 {
    font-size: 42px;
  }
}

@media (max-width: 767px) {
  .wt-civic-hero,
  .wt-civic-detail-header,
  .wt-civic-section-heading,
  .wt-civic-form-heading {
    display: block;
  }

  .wt-civic-hero {
    min-height: 0;
    padding: 34px 22px;
  }

  .wt-civic-hero h1,
  .wt-civic-detail-header h1 {
    font-size: 34px;
    overflow-wrap: anywhere;
  }

  .wt-civic-pulse,
  .wt-civic-detail-state {
    margin-top: 26px;
    text-align: left;
  }

  .wt-civic-filters,
  .wt-civic-record-grid,
  .wt-civic-facts {
    grid-template-columns: 1fr;
  }

  .wt-civic-record,
  .wt-civic-form,
  .wt-civic-detail-panel,
  .wt-civic-detail-header {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/styles/civic.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,yCAAyC;EACzC,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6FAA6F;EAC7F,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uJAAuJ;EACvJ,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,8CAA8C;EAC9C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,mEAAmE;AACrE;;AAEA;EACE,QAAQ;EACR,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;EACzC,qBAAqB;EACrB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;EACT,8CAA8C;AAChD;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+EAA+E;EAC/E,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kDAAkD;EAClD,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;;IAIE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;;;IAIE,aAAa;EACf;AACF","sourcesContent":[".wt-civic-page {\n  --civic-ink: #172336;\n  --civic-navy: var(--civic-primary, #15395f);\n  --civic-red: var(--civic-accent, #ba2d2d);\n  --civic-gold: #e5a229;\n  --civic-paper: var(--civic-surface, #f5f1e8);\n  color: var(--civic-ink);\n  font-family: var(--civic-font, inherit);\n}\n\n.wt-civic-hero {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  min-height: 270px;\n  margin-bottom: 0;\n  padding: 46px 52px;\n  overflow: hidden;\n  background: linear-gradient(120deg, var(--civic-navy) 0%, #1c4c76 64%, var(--civic-red) 100%);\n  color: #fff;\n}\n\n.wt-civic-hero::after {\n  content: '';\n  position: absolute;\n  right: -90px;\n  bottom: -145px;\n  width: 390px;\n  height: 390px;\n  border: 52px solid rgba(255, 255, 255, 0.06);\n  border-radius: 50%;\n}\n\n.wt-civic-hero-grid {\n  position: absolute;\n  inset: 0;\n  opacity: 0.12;\n  background-image: linear-gradient(rgba(255, 255, 255, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.3) 1px, transparent 1px);\n  background-size: 34px 34px;\n}\n\n.wt-civic-hero-copy,\n.wt-civic-pulse {\n  position: relative;\n  z-index: 1;\n}\n\n.wt-civic-hero-copy {\n  max-width: 720px;\n}\n\n.wt-civic-kicker {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--civic-gold);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.wt-civic-hero h1 {\n  margin: 0 0 15px;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 52px;\n  line-height: 1.05;\n}\n\n.wt-civic-hero p {\n  max-width: 680px;\n  margin: 0;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 18px;\n}\n\n.wt-civic-pulse {\n  width: 150px;\n  text-align: right;\n}\n\n.wt-civic-pulse strong {\n  display: block;\n  color: #fff;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 46px;\n  line-height: 1;\n}\n\n.wt-civic-pulse span {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.wt-civic-sections-shell {\n  position: relative;\n  margin-bottom: 38px;\n}\n\n.wt-civic-sections-shell::before,\n.wt-civic-sections-shell::after {\n  content: '';\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  bottom: 1px;\n  width: 24px;\n  pointer-events: none;\n}\n\n.wt-civic-sections-shell::before {\n  left: 0;\n  background: linear-gradient(90deg, var(--civic-paper), transparent);\n}\n\n.wt-civic-sections-shell::after {\n  right: 0;\n  background: linear-gradient(270deg, var(--civic-paper), transparent);\n}\n\n.wt-civic-sections {\n  display: flex;\n  gap: 0;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-color: var(--civic-red) #ded8cd;\n  scrollbar-width: thin;\n  border-bottom: 1px solid #d6d0c5;\n  background: var(--civic-paper);\n}\n\n.wt-civic-sections:focus-visible {\n  outline: 2px solid var(--civic-red);\n  outline-offset: 2px;\n}\n\n.wt-civic-sections a {\n  flex: 0 0 auto;\n  padding: 15px 17px;\n  border-bottom: 3px solid transparent;\n  color: #4b5360;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.wt-civic-sections a.active,\n.wt-civic-sections a:hover {\n  border-bottom-color: var(--civic-red);\n  color: var(--civic-red);\n}\n\n.wt-civic-section-heading,\n.wt-civic-form-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n\n.wt-civic-section-heading h2,\n.wt-civic-form-heading h3,\n.wt-civic-detail-panel h2 {\n  margin: 0;\n  font-family: Georgia, 'Times New Roman', serif;\n}\n\n.wt-civic-directory,\n.wt-civic-urgent,\n.wt-civic-compare,\n.wt-civic-form,\n.wt-civic-signin {\n  margin-bottom: 38px;\n}\n\n.wt-civic-filters {\n  display: grid;\n  grid-template-columns: minmax(220px, 2fr) minmax(150px, 1fr) minmax(150px, 1fr);\n  gap: 12px;\n  margin-bottom: 22px;\n  padding: 16px;\n  border: 1px solid #ddd6ca;\n  background: #faf8f3;\n}\n\n.wt-civic-filters label span {\n  display: block;\n  margin-bottom: 5px;\n  color: #667080;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.wt-civic-record-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.wt-civic-record {\n  position: relative;\n  min-width: 0;\n  padding: 20px;\n  border: 1px solid #d7dce2;\n  border-top: 4px solid var(--civic-navy);\n  background: #fff;\n  box-shadow: 0 8px 22px rgba(17, 38, 62, 0.05);\n}\n\n.wt-civic-record.is-critical {\n  border-top-color: var(--civic-red);\n}\n\n.wt-civic-record-topline,\n.wt-civic-record-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.wt-civic-kind {\n  color: #657080;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.wt-civic-status {\n  padding: 3px 7px;\n  border-radius: 2px;\n  background: #e8edf2;\n  color: #415268;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.wt-civic-status.status-verified,\n.wt-civic-status.status-resolved {\n  background: #dcefe5;\n  color: #216441;\n}\n\n.wt-civic-record h3 {\n  margin: 15px 0 9px;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 22px;\n}\n\n.wt-civic-record h3 a {\n  color: var(--civic-ink);\n}\n\n.wt-civic-record p {\n  color: #5b6470;\n}\n\n.wt-civic-record-meta {\n  justify-content: flex-start;\n  margin: 16px 0;\n  color: #78818d;\n  font-size: 11px;\n}\n\n.wt-civic-record-meta .severity-high,\n.wt-civic-record-meta .severity-critical {\n  color: var(--civic-red);\n  font-weight: 800;\n}\n\n.wt-civic-progress {\n  height: 6px;\n  margin: 16px 0;\n  overflow: hidden;\n  background: #e7ebee;\n}\n\n.wt-civic-progress span {\n  display: block;\n  height: 100%;\n  background: linear-gradient(90deg, var(--civic-gold), #5b9b6c);\n}\n\n.wt-civic-empty {\n  padding: 54px 20px;\n  border: 1px dashed #c8c3b9;\n  background: #faf8f3;\n  text-align: center;\n}\n\n.wt-civic-empty .fa {\n  color: #9aa1a8;\n  font-size: 40px;\n}\n\n.wt-civic-form,\n.wt-civic-signin,\n.wt-civic-compare {\n  padding: 26px;\n  border: 1px solid #d8d1c4;\n  background: var(--civic-paper);\n}\n\n.wt-civic-comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n  gap: 1px;\n  margin-top: 22px;\n  background: #cfd5da;\n}\n\n.wt-civic-comparison-grid > div {\n  padding: 22px;\n  background: #fff;\n}\n\n.wt-civic-detail-breadcrumb {\n  display: flex;\n  gap: 8px;\n  margin: 22px 0;\n}\n\n.wt-civic-detail-header {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 30px;\n  margin-bottom: 28px;\n  padding: 38px;\n  background: linear-gradient(115deg, #f4f0e7, #fff);\n  border-left: 7px solid var(--civic-red);\n}\n\n.wt-civic-detail-header h1 {\n  margin: 0 0 10px;\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 42px;\n}\n\n.wt-civic-detail-state {\n  min-width: 150px;\n  text-align: right;\n  text-transform: uppercase;\n}\n\n.wt-civic-detail-state span,\n.wt-civic-detail-state strong {\n  display: block;\n}\n\n.wt-civic-detail-state span {\n  color: var(--civic-red);\n  font-weight: 800;\n}\n\n.wt-civic-detail-panel {\n  margin-bottom: 20px;\n  padding: 24px;\n  border: 1px solid #d9dde2;\n  background: #fff;\n}\n\n.wt-civic-detail-panel h2 {\n  margin-bottom: 18px;\n}\n\n.wt-civic-description {\n  white-space: pre-wrap;\n}\n\n.wt-civic-facts {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.wt-civic-facts.stacked {\n  grid-template-columns: 1fr;\n}\n\n.wt-civic-facts div {\n  padding-bottom: 10px;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.wt-civic-facts dt {\n  color: #77818e;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.wt-civic-facts dd {\n  margin-top: 4px;\n}\n\n.wt-civic-outcome {\n  border-color: #d4b56d;\n  background: #fffaf0;\n}\n\n.wt-civic-history {\n  position: relative;\n  margin: 0;\n  padding: 0 0 0 22px;\n  list-style: none;\n}\n\n.wt-civic-history::before {\n  content: '';\n  position: absolute;\n  top: 5px;\n  bottom: 5px;\n  left: 4px;\n  width: 2px;\n  background: #d8dee4;\n}\n\n.wt-civic-history li {\n  position: relative;\n  margin-bottom: 22px;\n}\n\n.wt-civic-history li::before {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: -23px;\n  width: 12px;\n  height: 12px;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background: var(--civic-red);\n  box-shadow: 0 0 0 1px var(--civic-red);\n}\n\n.wt-civic-history time,\n.wt-civic-history strong,\n.wt-civic-detail-panel li small {\n  display: block;\n}\n\n.wt-civic-history time,\n.wt-civic-history small,\n.wt-civic-detail-panel li small {\n  color: #7c8590;\n  font-size: 11px;\n}\n\n.wt-civic-detail-panel li {\n  margin-bottom: 10px;\n}\n\n.wt-civic-knowledge-links {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.wt-civic-knowledge-links li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 0;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.wt-civic-knowledge-links li:last-child {\n  border-bottom: 0;\n}\n\n.wt-civic-knowledge-links a,\n.wt-civic-link-type {\n  display: block;\n}\n\n.wt-civic-link-type {\n  margin-bottom: 3px;\n  color: var(--civic-red);\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.wt-civic-knowledge-links p {\n  margin: 5px 0 0;\n  color: #667080;\n  font-size: 12px;\n}\n\n@media (max-width: 991px) {\n  .wt-civic-record-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .wt-civic-hero {\n    padding: 38px 30px;\n  }\n\n  .wt-civic-hero h1 {\n    font-size: 42px;\n  }\n}\n\n@media (max-width: 767px) {\n  .wt-civic-hero,\n  .wt-civic-detail-header,\n  .wt-civic-section-heading,\n  .wt-civic-form-heading {\n    display: block;\n  }\n\n  .wt-civic-hero {\n    min-height: 0;\n    padding: 34px 22px;\n  }\n\n  .wt-civic-hero h1,\n  .wt-civic-detail-header h1 {\n    font-size: 34px;\n    overflow-wrap: anywhere;\n  }\n\n  .wt-civic-pulse,\n  .wt-civic-detail-state {\n    margin-top: 26px;\n    text-align: left;\n  }\n\n  .wt-civic-filters,\n  .wt-civic-record-grid,\n  .wt-civic-facts {\n    grid-template-columns: 1fr;\n  }\n\n  .wt-civic-record,\n  .wt-civic-form,\n  .wt-civic-detail-panel,\n  .wt-civic-detail-header {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
